import {
  ADD_RISK_ASSESSMENT_FILE,
  ADD_RISK_ASSESSMENT_FILE_FAIL,
  ADD_RISK_ASSESSMENT_FILE_SUCCESS,
  GET_RISK_ASSESSMENT_LIST,
  GET_RISK_ASSESSMENT_LIST_FAIL,
  GET_RISK_ASSESSMENT_LIST_SUCCESS,
  DELETE_RISK_ASSESSMENT_FILE_FAIL,
  DELETE_RISK_ASSESSMENT_FILE_SUCCESS,
  DELETE_RISK_ASSESSMENT_FILE,
  UPDATE_STATUS_FAIL,
  UPDATE_STATUS_SUCCESS,
  UPDATE_STATUS,
} from "./actionTypes";

export const updateRiskAssessmentStatus = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_STATUS,
  payload: { data, onSuccess, onError },
});

export const updateRiskAssessmentStatusSuccess = data => ({
  type: UPDATE_STATUS_SUCCESS,
  payload: data,
});

export const updateRiskAssessmentStatusFail = data => ({
  type: UPDATE_STATUS_FAIL,
  payload: data,
});

export const deleteRiskAssessmentList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_RISK_ASSESSMENT_FILE,
  payload: { data, onSuccess, onError },
});

export const deleteRiskAssessmentListSuccess = data => ({
  type: DELETE_RISK_ASSESSMENT_FILE_SUCCESS,
  payload: data,
});

export const deleteRiskAssessmentListFail = data => ({
  type: DELETE_RISK_ASSESSMENT_FILE_FAIL,
  payload: data,
});

export const getRiskAssessmentList = (data = { page: 1, limit: 20, search: "" }) => ({
  type: GET_RISK_ASSESSMENT_LIST,
  payload: data,
});

export const getRiskAssessmentListSuccess = data => ({
  type: GET_RISK_ASSESSMENT_LIST_SUCCESS,
  payload: data,
});

export const getRiskAssessmentListFail = data => ({
  type: GET_RISK_ASSESSMENT_LIST_FAIL,
  payload: data,
});

export const addRiskAssessmentFile = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_RISK_ASSESSMENT_FILE,
  payload: { data, onSuccess, onError },
});

export const addRiskAssessmentFileSuccess = data => ({
  type: ADD_RISK_ASSESSMENT_FILE_SUCCESS,
  payload: data,
});

export const addRiskAssessmentFileFail = data => ({
  type: ADD_RISK_ASSESSMENT_FILE_FAIL,
  payload: data,
});
